import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useNotification(data = {}) {
  const { enabled = false, queryParams = '', notificationId } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getNotificationDetails() {
    return privateFetch.get(`/v1/admin/notification/${notificationId}`).then((res) => res.data);
  }

  return useQuery(['notification-details', notificationId, { data }], getNotificationDetails, {
    enabled,
  });
}

export default useNotification;
